// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1pZVu","additionalInfo":"AgreementModal_additionalInfo__38yuk"};